module.exports = __webpack_public_path__ + "static/media/icon_inbox_negociacion.b13fec27.svg";